import { mapActions, mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters('tutorial', ['turorialKey', 'tutorialCompleted', 'tutorialCompletionDate']),
    },
    methods: {
        ...mapActions('tutorial', ['completeTutorial', 'updateTutorial']),
    },
};
